export interface LoginParams {
  username: string;
  password: string;
}

export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
}

export enum LoginErrors {
  InvalidUserCredentialsExceptionError = 'InvalidUserCredentialsException',
  UnknownError = 'UnknownError',
  NoError = 'NoError',
}

export enum LoginErrorMessages {
  InvalidUserCredentialsExceptionMessage = 'LOGIN.ERROR_MESSAGE.INVALID_USER_CREDENTIALS_EXCEPTION',
  UnknownErrorMessage = 'LOGIN.ERROR_MESSAGE.UNKNOWN_ERROR',
  NoErrorMessage = '',
}

export interface LoginErrorResponse {
  error: string;
  message: string;
  timestamp: string;
}
